.discord-tenor-video {
	color: #dcddde;
	display: flex;
	font-size: 13px;
	line-height: 150%;
	margin-bottom: 8px;
	margin-top: 8px;
}

.discord-tenor-video .discord-tenor-video-wrapper {
	display: block;
	position: relative;
	-webkit-user-select: text;
	-moz-user-select: text;
	-ms-user-select: text;
	user-select: text;
	overflow: hidden;
	border-radius: 4px;
}

.discord-tenor-video .discord-tenor-video-wrapper video {
	-webkit-box-align: center;
	-webkit-box-pack: center;
	align-items: center;
	border-radius: 0;
	cursor: pointer;
	display: flex;
	height: 100%;
	justify-content: center;
	max-height: 100%;
	width: 100%;
	left: 0px;
	top: 0px;
}
